import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TemplatesPage from './pages/TemplatesPage';
import PricingPage from './pages/PricingPage';
import CarouselGeneratorPage from './pages/CarouselGeneratorPage';
import CarouselPreviewPage from './pages/CarouselPreviewPage';
import CarouselDetailPage from './pages/CarouselDetailPage';
import VideoTemplatesPage from './pages/VideoTemplatesPage';
import EditorPage from './pages/EditorPage';
import NotFoundPage from './pages/NotFoundPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import RefundPolicyPage from './pages/RefundPolicyPage';

// Admin Pages
import EmailCampaignDashboard from './pages/admin/EmailCampaignDashboard';
import EmailTemplateList from './pages/admin/EmailTemplateList';
import EmailCampaignList from './pages/admin/EmailCampaignList';
import EmailCampaignForm from './pages/admin/EmailCampaignForm';
import EmailCampaignDetail from './pages/admin/EmailCampaignDetail';

// Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';

function AppLayout() {
  const location = useLocation();
  const isEditor = location.pathname.startsWith('/editor');

  return (
    <div className={isEditor
      ? 'h-screen overflow-hidden flex flex-col bg-gray-50'
      : 'min-h-screen bg-gray-50 flex flex-col'
    }>
      <Navbar />
      <main className={isEditor
        ? 'flex-1 overflow-hidden flex flex-col'
        : 'flex-grow'
      }>
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* Registration disabled - using social auth only */}
            {/* <Route path="/register" element={<RegisterPage />} /> */}
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/terms-and-conditions" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } />
            <Route path="/create" element={
              <ProtectedRoute>
                <CarouselGeneratorPage />
              </ProtectedRoute>
            } />
            <Route path="/generate" element={
              <ProtectedRoute>
                <CarouselGeneratorPage />
              </ProtectedRoute>
            } />
            <Route path="/carousel/:id" element={
              <ProtectedRoute>
                <CarouselDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/preview" element={
              <ProtectedRoute>
                <CarouselPreviewPage />
              </ProtectedRoute>
            } />
            <Route path="/video-templates" element={
              <ProtectedRoute>
                <VideoTemplatesPage />
              </ProtectedRoute>
            } />
            {/* EDITOR ROUTES - Konva.js Implementation */}
            <Route path="/editor" element={
              <ProtectedRoute>
                <EditorPage />
              </ProtectedRoute>
            } />
            <Route path="/editor/:carouselId" element={
              <ProtectedRoute>
                <EditorPage />
              </ProtectedRoute>
            } />
            
            {/* Admin Routes - Email Campaigns */}
            <Route path="/admin/email-campaigns" element={
              <AdminRoute>
                <EmailCampaignDashboard />
              </AdminRoute>
            } />
            <Route path="/admin/email-campaigns/templates" element={
              <AdminRoute>
                <EmailTemplateList />
              </AdminRoute>
            } />
            <Route path="/admin/email-campaigns/campaigns" element={
              <AdminRoute>
                <EmailCampaignList />
              </AdminRoute>
            } />
            <Route path="/admin/email-campaigns/campaigns/new" element={
              <AdminRoute>
                <EmailCampaignForm />
              </AdminRoute>
            } />
            <Route path="/admin/email-campaigns/campaigns/:id" element={
              <AdminRoute>
                <EmailCampaignDetail />
              </AdminRoute>
            } />
            <Route path="/admin/email-campaigns/campaigns/:id/edit" element={
              <AdminRoute>
                <EmailCampaignForm />
              </AdminRoute>
            } />
            
            {/* 404 Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
      {!isEditor && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppLayout />
    </AuthProvider>
  );
}

export default App;
